/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const DataExportStatus = {
    Pending: 'Pending',
    Building: 'Building',
    Ready: 'Ready',
    Failed: 'Failed',
    Expired: 'Expired'
};
export function DataExportStatusFromJSON(json) {
    return DataExportStatusFromJSONTyped(json, false);
}
export function DataExportStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function DataExportStatusToJSON(value) {
    return value;
}
